module.exports = __webpack_public_path__ + "static/p6-462a0cacad461eb80f29cbd4c6b09a9b.jpg";